import { OGCCapabilityLayerEntity } from '../entities/ogc-capability-layer-entity'

export class OGCCapabilitiesValueObject {
  constructor(
    public readonly layers: OGCCapabilityLayerEntity[],
    public readonly effectiveUrl: string,
  ) {}
}
